import PublicLock from "../solidity/PublicLock.json";

export const coinageTrialRead = {
  address: process.env.NEXT_PUBLIC_COINAGE_TRIAL_ADDRESS as `0x${string}`,
  abi: PublicLock,
  chainId: 8453
};
